import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default {
	styleOverrides: {
		root: {
			borderRadius: '8px',
			'&:focus': {
				background: 'inherit',
			},
			'&::after': {
				display: 'none',
			},
			'&::before': {
				display: 'none',
			},
		},
		select: {
			'&:focus': {
				background: 'inherit',
			},
		},
		standard: {
			padding: 0,
			fontSize: '14px',
			fontWeight: 600,
			lineHeight: '22px',
			letterSpacing: '0.1px',
			paddingRight: '32px',
		},
		icon: {
			transition: 'all .3s',
		},
	},
	defaultProps: {
		IconComponent: KeyboardArrowDownIcon,
		MenuProps: { slotProps: { paper: { sx: { backdropFilter: 'blur(10px)' } } } },
	},
};
